// components/ui/Form/PhoneInput.tsx
import { forwardRef, useRef, useImperativeHandle, useEffect } from "react";
import { FormInputLayout } from "./FormInputLayot";
import CustomInput from "../CustomInput";
import IMask from "imask";

type PhoneInputProps = {
  name: string;
  label?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  clearable?: boolean;
};

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ name, label, error, value, onChange, className, clearable }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const maskRef = useRef<any>(null);

    useImperativeHandle(ref, () => inputRef.current!);

    // Инициализация маски
    useEffect(() => {
      if (inputRef.current) {
        maskRef.current = IMask(inputRef.current, {
          mask: '+7 (000) 000-00-00',
          lazy: false,
          placeholderChar: '_'
        });

        maskRef.current.on('accept', () => {
          onChange?.(maskRef.current.value);
        });

        return () => {
          if (maskRef.current) {
            maskRef.current.destroy();
          }
        };
      }
    }, [onChange]);

    // Обновление значения извне
    useEffect(() => {
      if (maskRef.current && value !== undefined && value !== maskRef.current.value) {
        maskRef.current.value = value;
      }
    }, [value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // Обновляем маску при ручном вводе
      if (maskRef.current) {
        maskRef.current.updateValue();
      }
    };

    return (
      <FormInputLayout name={name} label={label} error={error}>
        <CustomInput
          ref={inputRef}
          value={value || ''}
          onChange={handleInputChange}
          name={name}
          autoComplete="tel"
          className={className}
          clearable={clearable}
        />
      </FormInputLayout>
    );
  }
);

PhoneInput.displayName = "PhoneInput";